import { action } from '@ember/object';

import type { Args as BaseArgs } from 'webapp/components/common/upgrade-plan-base';
import CommonUpgradePlanBaseComponent from 'webapp/components/common/upgrade-plan-base';
import SubmitButtonComponent from 'webapp/components/submit-button';

interface Args extends BaseArgs {
	size?: string;
	theme?: string;
	submitInProgress?: boolean;
	onTrigger?: () => void;
}

export default abstract class CommonUpgradePlanButtonComponent<
	T extends Args,
> extends CommonUpgradePlanBaseComponent<T> {
	@action
	override handleLimitations(): void {
		super.handleLimitations();

		const { onTrigger } = this.args;
		if (onTrigger) {
			onTrigger();
		}
	}
	<template>
		<SubmitButtonComponent
			@text={{this.text}}
			@size={{@size}}
			@icon={{@icon}}
			@theme={{@theme}}
			@extraClass="upgrade-plan-button"
			@noDelay={{true}}
			@submitInProgress={{@submitInProgress}}
			@onTrigger={{this.handleLimitations}}
		/>
	</template>
}
